module.exports = __webpack_public_path__ + "static/img/game_screenshot.aea3041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game_screenshot.png
// module id = BFUT
// module chunks = 1